<template>
    <div style="height:100%">
      <swiper :options="swiperOption" class="swiper-box">
          <swiper-slide class="swiper-item" v-for="img in mapPic" :key="img"><img :src=img /></swiper-slide>
        <div class="swiper-pagination " slot="pagination"></div>
      </swiper>
    </div>
</template>

<script>
import api from '@/script/util'
import { swiper, swiperSlide, swiperPlugins } from 'vue-awesome-swiper'
import '@/style/base.css'
export default {
  name: '', // 小镇地图
  components: {
    swiper,
    swiperSlide,
    swiperPlugins
  },
  data () {
    return {
      mapPic: [],
      swiperOption: {
        // 如果你后续需要找到当前实例化后的swiper对象以对其进行一些操作的话，可以自定义配置一个名字
        name: 'currentSwiper',
        // 所有配置均为可选（同Swiper配置）
        autoplay: false,
        direction: 'horizontal',
        pagination: '.swiper-pagination',
        // paginationType: 'fraction',
        paginationClickable: true,

        mousewheelControl: true,
        observeParents: true
        // more Swiper config ...
        // ...
      }
    }
  },
  created: function () {
    document.title = '小镇地图'
    let params = {
      townId: api.getVal('townId')
    }
    console.log(this.roomLists)
    api.GetMapDetail(params)
      .then(res => {
        console.log(res)
        this.mapPic = res
      })
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// townMap.vue?32167b9a